module.exports = __webpack_public_path__ + "img/MES4Indice5_cutout.26e15000.png";